// Central navigation config for The Vault
export const NAV_GROUPS = [
  {
    key: 'home',
    label: 'Home',
    icon: 'Home',
    path: '/',
    items: [],
  },
  {
    key: 'datatables',
    label: 'DataTables',
    icon: 'Layers',
    path: '/dt',
    items: [
      { label: 'Commodities', path: '/commodities' },
      { label: 'Customers', path: '/customers' },
      { label: 'Varieties', path: '/varieties' },
      { label: 'Grades', path: '/grades' },
      { label: 'Ti x Hi', path: '/tihi' },
      { label: 'Case Tags', path: '/case-tags' },
      { label: 'Bag Traceability', path: '/bag-traceability' },
      { label: 'Bag Costs', path: '/bag-costs' },
      { label: 'Bag Material', path: '/bag-material' },
      { label: 'Labor', path: '/labor' },
      { label: 'Methods', path: '/methods' },
      { label: 'Pack Types', path: '/pack-types' },
      { label: 'Setup Charges', path: '/setup-charges' },
      { label: 'Size Options', path: '/size-options' },
    ],
  },
  {
    key: 'charges',
    label: 'Charges',
    icon: 'DollarSign',
    path: '/charges',
    items: [
      { label: 'Charge By Style', path: '/charge-by-style' },
      { label: 'Charge Search Index', path: '/charge-search-index' },
    ],
  },
  {
    key: 'packaging',
    label: 'Packaging',
    icon: 'Package',
    path: '/packaging',
    items: [
      { label: 'Package Index', path: '/package-index' },
      { label: 'Methods', path: '/pid-methods' },
      { label: 'Labels', path: '/pid-bags' },
      { label: 'PLU', path: '/pid-plu' },
      { label: 'UPC', path: '/pid-upc' },
      { label: 'Displays', path: '/pid-displays' },
    ],
  },
  {
    key: 'customer-specs',
    label: 'Customer Specifications',
    icon: 'ClipboardList',
    path: '/customer-specs',
    items: [
      { label: 'Spec Index', path: '/CustomerSpecs/Index' },
      { label: 'Entry Form', path: '/CustomerSpecs/Form' },
      { label: 'Manage', path: '/CustomerSpecs/Manage' },
    ],
  },
  {
    key: 'settings',
    label: 'Settings',
    icon: 'Settings',
    path: '/settings',
    items: [],
  },
];


